import { Pagination } from '@/Domain/Procedures/RepositoryModifiers/Pagination'
import { UserExpedienteRepository } from '@/Domain/Expediente/UserExpedienteRepository'
import { AccountId } from '@/Domain/Account'
import { ExpedienteFilters, Expediente, Award, ReferenciaExpediente, Execution, HeavyTickets, HeavyTicket, Recognition, Accounting, AccountingAward, FinalSettlement, FinalSettlementPositive, FinalSettlementNegative, DefinitiveWarrantyRefund, ExpedienteState, Payment, FirstPayment, SecondPayment } from '@/Domain/Expediente'
import { NewDate, NewHour } from '@/Domain/News'
import { Currency } from '@/Domain/Batch/Currency'
import { Percentage } from '@/Domain/Expediente/Percentage'
import { ProcedureNotFoundError } from '@/Domain/Procedures'
import { OfferTarget } from '@/Domain/Offer'
import { DanosEvitables } from '@/Domain/Expediente/DanosEvitables'
import { DanosMadeirables } from '@/Domain/Expediente/DanosMadeirables'
import { DanosNonMadeirables } from '@/Domain/Expediente/DanosNonMadeirables'

const createExpedientes = () => {
  return [
    new Expediente(new ReferenciaExpediente('999888777666'), '099/20', 'V999999', '(999) Con datos de detalle', 'Ourense', 'Verín', 'Cualedro', new NewDate('29/05/2020'), new NewDate('29/08/2020'), ExpedienteState.EXECUCION,
      new Award('Madereriro de Proba', new Currency(15088), false, new Percentage(20), new NewDate('18/05/2020'), new NewDate('18/05/2020'), new Currency(100),
        new Percentage(0), new Currency(0), new Percentage(0), new Currency(0), new Percentage(0), new Currency(0),
        new NewDate('18/05/2020'), new NewDate('18/05/2020'), new NewDate('18/05/2020'), new NewDate('18/05/2020'), new NewDate('18/05/2020'), new NewDate('18/05/2020'), new NewDate('18/05/2020'), new NewDate('18/05/2020')),
      new Execution('RISCO', new NewDate('05/05/2020'), new NewDate('05/05/2020'), 1, new NewDate('05/05/2020'), true, 2, new NewDate('05/05/2020'), 'Favorable', new NewDate('05/05/2020'), new NewDate('05/05/2020'), 'Observaciones Execución', 54687,
        new HeavyTickets([
          new HeavyTicket('Roble', 4, OfferTarget.SERRA1, '123123', new NewDate('25/11/2020'), new Currency(500), new Currency(54612)),
          new HeavyTicket('Roble', 3, OfferTarget.TRITURACION, '123123', new NewDate('25/11/2020'), new Currency(985), new Currency(98754)),
          new HeavyTicket('Roble', 3, OfferTarget.TRITURACION, '123123', new NewDate('25/11/2020'), new Currency(985), new Currency(98754)),
          new HeavyTicket('Castaño', 3, OfferTarget.SERRA2, '123123', new NewDate('25/11/2020'), new Currency(985), new Currency(98754)),
          new HeavyTicket('Castaño', 3, OfferTarget.SERRA2, '123123', new NewDate('25/11/2020'), new Currency(985), new Currency(98754)),
          new HeavyTicket('Nogal', 3, OfferTarget.SERRA2, '123123', new NewDate('25/11/2020'), new Currency(985), new Currency(98754))
        ], new Currency(500))
      ),
      new Recognition(new NewDate('18/01/2020'), new NewHour('20:20'), '12054M', 'Cortado y limpio', true, 'Inevitables', 'Madeirables',
        new DanosEvitables('descripcion', new Currency(500), new Percentage(7), new NewDate('01/09/2020')),
        new DanosMadeirables(new Currency(450), new Percentage(10), new Currency(89), new Currency(522), new NewDate('02/09/2020'), new NewDate('20/09/2020')),
        new DanosNonMadeirables(new Currency(980), new Percentage(2), new Currency(20), new Currency(1000), new NewDate('02/09/2020'), true, new NewDate('08/10/2021'))),
      new Accounting(
        new AccountingAward(new Currency(18050), new Percentage(22), new Currency(50), new NewDate('12/12/2020'), new NewDate('25/05/2020'), new Percentage(22), new Currency(50856), new NewDate('06/06/2020'), new Percentage(12), new Currency(5623456), new NewDate('16/08/2020'), 'RESUL'),
        new FinalSettlement(new Currency(5468), new Currency(789435), new Currency(86454), new Currency(456465), 256),
        new FinalSettlementPositive(new Currency(4564), new Percentage(12), new Currency(4564), new NewDate('12/12/2020'), new NewDate('06/06/2020'), new Percentage(50), new Currency(456321), new NewDate('05/05/2020'), new Percentage(23), new Currency(1234897), new NewDate('18/05/2020')),
        new FinalSettlementNegative(new Currency(123456), new Currency(456465), new Currency(456465), new NewDate('25/12/2020')),
        new DefinitiveWarrantyRefund(
          'Devolucion a plazos',
          new Currency(456789),
          new NewDate('01/01/2021'),
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null
        ),
        new Payment(new Currency(3000), new Currency(120), new NewDate('01/09/2020'), new NewDate('09/09/2020'), new Percentage(3), new Currency(33), new NewDate('15/09/2020'), new Percentage(6), new Currency(22), new NewDate('22/09/2020')),
        new FirstPayment(new Currency(1000), new Currency(200), new Currency(630), new NewDate('07/11/2020'), new NewDate('07/11/2020'), new Percentage(11), new Currency(321), new NewDate('02/12/2020'), new Percentage(7), new Currency(120), new NewDate('07/12/2020')),
        new SecondPayment(new Currency(200), new NewDate('15/11/2020'), new Percentage(10), new Currency(23), new NewDate('17/11/2020'), new Percentage(6), new Currency(56), new NewDate('20/11/2020')), true, true
      ),
      new Currency(500)
    ),
    new Expediente(new ReferenciaExpediente('320282000099'), '099/20', 'V999999', '(999) Sin datos de detalle', 'Ourense', 'Verín', 'Cualedro', new NewDate('29/05/2020'), new NewDate('29/08/2020'), ExpedienteState.EXECUCION, null, null, null, null, null),
    new Expediente(new ReferenciaExpediente('123456789123'), '098/20', 'V999999', '(999) Sin datos de detalle', 'Ourense', 'Verín', 'Cualedro', new NewDate('29/04/2020'), new NewDate('29/08/2020'), ExpedienteState.DESERTO, null, null, null, null, null),
    new Expediente(new ReferenciaExpediente('987654321987'), '097/20', 'V999999', '(999) Con algunos datos de detalle', 'Pontevedra', 'Vigo', 'Vigo', new NewDate('30/05/2020'), new NewDate('30/08/2020'), ExpedienteState.PECHADO,
      new Award('Paquito', new Currency(15088), false, new Percentage(20), new NewDate('18/05/2020'), new NewDate('18/05/2020'), new Currency(100),
        new Percentage(0), new Currency(0), new Percentage(0), new Currency(0), new Percentage(0), new Currency(0),
        new NewDate('18/05/2020'), new NewDate('18/05/2020'), new NewDate('18/05/2020'), new NewDate('18/05/2020'), new NewDate('18/05/2020'), new NewDate('18/05/2020'), new NewDate('18/05/2020'), new NewDate('18/05/2020')), null, null, null, null
    )
  ]
}
async function wait (ms: number) {
  return new Promise(resolve => {
    setTimeout(resolve, ms)
  })
}

export class InMemoryExpedienteRepository implements UserExpedienteRepository {
  async byUser (
    accountId: AccountId,
    pagination: Pagination,
    filters: ExpedienteFilters
  ): Promise<Expediente[]> {
    const duration = 300
    await wait(duration)
    const expedientes = createExpedientes()
    const startItem = (pagination.page - 1) * pagination.itemsPerPage
    const endItem = pagination.page * pagination.itemsPerPage
    const slicedExpedientes = expedientes.slice(startItem, endItem)
    const filteredExpedientes = this.filterExpedientes(slicedExpedientes, filters)
    const sortedExpedientes = this.sortProcedures(filteredExpedientes)
    return sortedExpedientes
  }

  // eslint-disable-next-line
  async totalItemsByUserCount (accountId: AccountId, filters: ExpedienteFilters): Promise<number> {
    const duration = 100
    await wait(duration)
    const expedientes = createExpedientes().slice(0, 1)
    const filteredExpedientes = this.filterExpedientes(expedientes, filters)
    return filteredExpedientes.length
  }

  async byNumReferencia (numExpediente: ReferenciaExpediente): Promise<Expediente> {
    const duration = 300
    await wait(duration)
    const expedientes = createExpedientes()
    const filteredExpediente = expedientes.filter(current => {
      return current.numExpediente === numExpediente.referencia
    })
    if (filteredExpediente.length === 0) {
      throw new ProcedureNotFoundError(`Expediente ${numExpediente} not found!!!`)
    }
    return filteredExpediente[0]
  }

  private filterExpedientes (procedures: Expediente[], filters: ExpedienteFilters): Expediente[] {
    return procedures.filter(item => {
      let matches = true
      if (filters.numExpediente) {
        matches = matches && item.numExpediente.indexOf(filters.numExpediente) !== -1
      }
      if (filters.province) {
        matches = matches && item.provincia === filters.province
      }
      if (filters.lote) {
        matches = matches && item.lote === filters.lote
      }
      return matches
    })
  }

  // eslint-disable-next-line
  private sortProcedures (procedures: Expediente[]): Expediente[] {
    const orderFunction = this.sortByCode
    return procedures.sort(orderFunction)
  }

  private sortByCode (a: Expediente, b: Expediente): number {
    return a.numExpediente.localeCompare(b.numExpediente)
  }
}
